<div class="{{ risk | lowercase }}" [innerHTML]="svg | safehtml"></div>